import { call, put, takeLatest , select } from 'redux-saga/effects';

import ApiRouts from '../../api/routes';
import {GET, POST} from "../../api";
import {
    FETCH_LICENCE, FETCH_LIKE, FETCH_PRODUCT_LIST,
    FETCH_SHOW_MORE_PRODUCT_LIST,
    SET_LICENCE, SET_LIKE
} from "../actions";
import {useDispatch} from "react-redux";
import { notification } from 'antd';


const getLikeFormId = (state) => state.likeFormId;


export function* FetchLikeSaga() {


    const likeFormId = yield select(getLikeFormId);


    try {


        const response = yield call(POST, `${ApiRouts.API_LIKE}/${likeFormId}`);

        if (response) {

            yield put({
                type:SET_LIKE,
                payload:response.data.data
            });

            // yield put({ type: FETCH_PRODUCT_LIST });
            // yield put({ type: FETCH_SHOW_MORE_PRODUCT_LIST });

        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        
    }
}

// Watcher Saga
function* likeSaga() {
    yield takeLatest(FETCH_LIKE, FetchLikeSaga);
}

export default likeSaga;
